import React, { useEffect, useState } from 'react';
import { PlanSelection } from '../../components/Billing/PlanSelection';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const BillingPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showCancel, setShowCancel] = useState(false);

  useEffect(() => {
    // URLパラメータからsuccess/cancelステータスを検出
    const success = searchParams.get('success') === 'true';
    const cancel = searchParams.get('cancel') === 'true';
    
    if (success) {
      setShowSuccess(true);
      // URLパラメータを自動的にクリア（ブラウザの更新時に通知が再表示されないように）
      window.history.replaceState({}, document.title, '/billing');
    }
    
    if (cancel) {
      setShowCancel(true);
      window.history.replaceState({}, document.title, '/billing');
    }
  }, [searchParams]);

  return (
    <div className="billing-page">
      <div className="container">
        {showSuccess && (
          <div className="alert alert-success payment-success-alert">
            <span className="success-icon">✓</span>
            <div>
              <h4>{t('billing.paymentCompleted')}</h4>
              <p>{t('billing.subscriptionCompleted')}</p>
            </div>
          </div>
        )}
        
        {showCancel && (
          <div className="alert alert-info payment-cancel-alert">
            <p>{t('billing.paymentCanceled')}</p>
          </div>
        )}
        
        <PlanSelection />
      </div>
    </div>
  );
};